import { Box, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { FilterModal } from "../../commons/filters/FilterModal.js";
import { FilterCheckbox } from "../../commons/filters/index.js";
import { OutgoingInvoicesFilter } from "../../main-routes/documents/Invoices.js";
import { InvoiceStatusSelect } from "./filters/InvoiceStatus.js";

export function InvoicesFilterModal<F extends OutgoingInvoicesFilter>({
  handleClose,
  filters,
  setFilters,
  resetFilters,
  tab,
}: {
  handleClose: () => void;
  filters: F;
  setFilters: React.Dispatch<React.SetStateAction<F>>;
  resetFilters: () => void;
  tab: "outgoing" | "incoming";
}) {
  const { t } = useTranslate(["Invoices", "ProjectOverview"]);

  const [filtersState, setFiltersState] = React.useState(filters);

  return (
    <FilterModal
      title={t("Invoices Filters", {
        ns: "Invoices",
      })}
      handleApply={() => {
        setFilters(filtersState);
      }}
      handleClose={handleClose}
      handleReset={() => resetFilters()}
      spacing={2}
    >
      <Stack direction="column" spacing={1}>
        <Box>
          <InvoiceStatusSelect
            value={filtersState.filterStatus ?? []}
            setValue={newValue =>
              setFiltersState(state => ({
                ...state,
                filterStatus: newValue,
              }))
            }
            tab={tab}
          />
        </Box>
        <Box>
          <FilterCheckbox
            label={t("Overdue", {
              ns: "ProjectOverview",
            })}
            value={filtersState.filterOverdue ?? undefined}
            setValue={newValue =>
              setFiltersState(state => ({
                ...state,
                filterOverdue: newValue,
              }))
            }
          />
        </Box>
      </Stack>
    </FilterModal>
  );
}
